export default [
  {
    path: '/settings/return-reason-types',
    name: 'return-reason-type-list',
    component: () => import('@/views/settings/ReturnReasonTypes.vue'),
    meta: {
      pageTitle: 'Motif de retour',
      breadcrumb: [
        { text: 'Paramètres', to: { name: 'parameters' } },
        { text: 'Motif de retour', active: true },
      ],
      requiresAdmin: true,
    },
  },
  {
    path: '/settings/parameters',
    name: 'parameters',
    component: () => import('@/views/settings/Parameters.vue'),
    meta: {
      pageTitle: 'Paramètres',
      breadcrumb: [
        { text: 'Paramètres', active: true },
      ],
      requiresAdmin: true,
      requireLogin: true,
    },
  },
]
